import {
  Component,
  Host,
  h,
  Element
} from "@stencil/core";

/**
 * @slot - Slot for `stzh-skiplink` elements
 */
@Component({
  tag: "stzh-page-skiplinks",
  styleUrl: "stzh-page-skiplinks.scss",
  scoped: true
})
export class StzhPageSkiplinks {
  @Element() element: HTMLStzhPageSkiplinksElement;

  private observer: MutationObserver;

  private init = () => {
    const links = this.element.querySelectorAll('stzh-skiplink');

    links.forEach((link) => {
      link.setAttribute("role", "listitem");
    });
  }

  connectedCallback() {
    this.init();

    this.observer = new MutationObserver(this.init);
    this.observer.observe(this.element, {
      childList: true,
      subtree: true
    });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  render() {
    return (
      <Host>
        <div class="stzh-page-skiplinks" role="list">
          <slot></slot>
        </div>
      </Host>
    );
  }
}
